export const downloadFile = (document: Document, dataUrl: string, fileName: string, extension: string) => {
	const element = document.createElement('a')
	element.href = dataUrl
	element.download = `${fileName}.${extension}`
	document.body.appendChild(element)
	element.click()
	document.body.removeChild(element)
}